import Swal from "sweetalert2";
import "../global.css";
import Pagination from "@material-ui/lab/Pagination";
import { t } from "i18next";
import CustomTextInput from "./CustomInput";
import LoginHeader from "./Header/LoginHeader";
import Header from "./Header";
import Footer from "./Footer";
import StarRating from "./StarRating";
import DotsLoader from "./DotsLoader";
import ImageAvatar from "./ImageAvatar";
import ImageMultiAvatar from "./ImageMultiAvatar";
import SearchCard from "./SearchCard";
import RenderPagination from "./Pagination";
import ProductCard from "./ProductCard";
import ProductGridCard from "./ProductCard/ProductGridCard";
import ProductLocationCard from "./ProductCard/ProductLocationCard";
import LocationSearch from "./LocationSearchModal";
import MapLocation from "./MapLocation";
import Calender from "./Calender";
import TranslatorDropdown from "./TranslatorDropdown";
import InputTypePhone from "./InputTextCustom/InputTypePhone";

// regex

const nameRegex = /^[a-zA-Z]+$/;
const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const passwordRegex = /^.{8,}$/;
const phoneNoRegex =
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
async function Validation(value, regex, message, optional) {
  if (!optional) {
    if (value == "" || value == null || String(() => value.trim()) == "") {
      return await "This field is requried";
    } else {
      if (await regex.test(value)) {
        return await null;
      } else {
        return await message;
      }
    }
  }
}

// Footer Component

function ErrorHelper(err, doAlert) {
  if (doAlert) {
    if (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err,
        confirmButtonColor: "#3fa9f5",
      });
    }
  }
}

const ErrorMessage = (error) => {
  if (error.response) {
    ErrorHelper(error.response?.data?.message, true);
  } else if (error.request) {
    ErrorHelper(t("Connection_Issue"), true);
  } else {
    ErrorHelper(error.errors, true);
  }
};

// Swal Success Helper Component

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

const handleSuccess = (msg, doAlert, title) => {
  if (doAlert) {
    if (msg) {
      Swal.fire({
        icon: "success",
        title: title ? title : t("Success"),
        text: msg,
        confirmButtonColor: "#3fa9f5",
      });
    }
  }
};

const handleToastSuccess = (msg, doAlert) => {
  if (doAlert) {
    if (msg) {
      Toast.fire({
        icon: "success",
        title: msg,
      });
    }
  }
};

// pagination

const ShowPagination = ({ totalCounting, page, pageChange }) => {
  return (
    <>
      {totalCounting > 0 ? (
        <div className="paginatio-middle">
          <Pagination
            count={totalCounting}
            page={page}
            shape="rounded"
            onChange={pageChange}
          />
        </div>
      ) : null}
    </>
  );
};

function NoDataFound({ validationText }) {
  return (
    <div className="d-flex justify-content-center text-20-bold">
      {validationText ? validationText : t("No_Data_Found")}
    </div>
  );
}

export {
  CustomTextInput,
  LocationSearch,
  nameRegex,
  emailRegex,
  passwordRegex,
  phoneNoRegex,
  Validation,
  ErrorHelper,
  ErrorMessage,
  handleSuccess,
  handleToastSuccess,
  Footer,
  StarRating,
  DotsLoader,
  ImageAvatar,
  ShowPagination,
  ImageMultiAvatar,
  Header,
  TranslatorDropdown,
  LoginHeader,
  SearchCard,
  RenderPagination,
  ProductCard,
  NoDataFound,
  MapLocation,
  ProductGridCard,
  ProductLocationCard,
  Calender,
  InputTypePhone,
};
